import { CamcomNext } from "../components/";
import { createBrowserRouter } from "react-router-dom";

/*
 * One route, at the domain root.
 *
 * This is deliberate and the deployment depends on it: with nothing but "/" there are no
 * client-side paths for the host to resolve, so a static host needs no SPA fallback — no
 * rewrite rule, no 403/404 mapping to index.html. Adding a second path would reintroduce
 * that requirement, so it is a deployment decision, not just a routing one.
 */
export default function routes() {
  return createBrowserRouter([
    {
      path: "/",
      element: <CamcomNext />,
    },
  ]);
}
